__webpack_require__.p = "https://dpsg-os.de/wp-content/themes/dpsg_os_2021/";